module.exports = __webpack_public_path__ + "img/circle-ico.7495f188.svg";